/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authCreatePosts.defs.js'
export { main as default } from './authCreatePosts.defs.js'
